import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuarioService } from 'src/app/services/http/usuario.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss']
})
export class RecuperarSenhaComponent implements OnInit {
  etapa: number = 1; // Controla a etapa do fluxo de recuperação de senha
  form: FormGroup;
  emailMascarado: string = "";
  email = new FormControl('', [Validators.required, Validators.email])
  login = new FormControl('', [Validators.required])
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private msgService: ModalMsgService
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      login: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
    });

    // Preencher o campo de login automaticamente, se fornecido pela URL
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as { login: string };
    if (state && state.login) {
      this.form.controls["login"].setValue(state.login);
    }
  }

  proximaEtapa() {
    if (this.etapa === 1) {
      if (this.form.controls["login"].invalid) {
        this.form.controls["login"].markAsTouched();
        return;
      }

      const login = this.form.controls["login"].value;

      this.usuarioService.obterEmailMascarado(login).then((result) => {
        if (result["msg"] == "Login não encontrado.") {
          this.msgService.openDialog("Erro", "Login não encontrado.", "danger");
        } else {
          this.emailMascarado = result["email"]; // Recebe o email mascarado do backend
          this.etapa = 2; // Avança para a próxima etapa
        }

      }).catch(() => {
        this.msgService.openDialog("Erro", "Login não encontrado.", "danger");
      });
    } else if (this.etapa === 2) {
      if (this.form.controls["email"].invalid) {
        this.form.controls["email"].markAsTouched();
        return;
      }

      const { login, email } = this.form.value;

      this.usuarioService.recuperarSenha(email, login)
        .then(() => {
          this.msgService.openDialog(
            "E-mail enviado",
            "Verifique sua caixa de entrada para a nova senha.",
            "success"
          );
        })
        .catch(() => {
          this.msgService.openDialog(
            "Erro",
            "Não foi possível enviar a senha. Verifique os dados e tente novamente.",
            "danger"
          );
        });
    }
  }

  voltarEtapa() {
    if (this.etapa > 1) {
      this.etapa--;
    }

  }
}
